import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { membership } from '../assets/icons';
import { YellowButton } from './Buttons';

const { fonts } = themes;

interface Props {
  id?: string;
  icon?: string;
  title?: string;
  description?: string;
  cta?: string;
  onClick: () => void;
}

const ConfirmationCard = ({ icon, title, description, cta, onClick }: Props) => {
  return (
    <Card>
      <img src={icon} alt="" />
      <Title>{title}</Title>
      <Description>{description}</Description>
      <YellowButton onClick={onClick}>{cta}</YellowButton>
    </Card>
  );
};

const MembershipConfirmationCard = ({ onClick }: Props) => {
  return (
    <ConfirmationCard
      icon={membership}
      title="Kindbody Member"
      description="Ready to take advantage of your membership benefits?"
      cta="Book an appointment"
      onClick={onClick}
    />
  );
};

const Card = styled.div`
  max-width: 300px;
  padding: 20px;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
  text-align: center;
`;

const Title = styled.div`
  ${fonts.DomaineDisplay};
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
`;

const Description = styled.div`
  ${fonts.FoundersGrotesk};
  font-size: 16px;
  margin-bottom: 28px;
`;

export { MembershipConfirmationCard };
